const FilesFilter = function (file) {
     debugger
    // Accept images only
    try {
        
    
    if (!file.name.match(/\.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|pdf|PDF|doc|docx|})$/)) {
        // req.fileValidationError = 'Only image files are allowed!';
        return false
    }else{
        return true
    }
} catch (error) {
       return false 
}
};

const excelFilter = function (req, file, cb) {
    // Accept excel only
    if (!file.originalname.match(/\.(xlsx|xls|csv})$/)) {
        req.fileValidationError = 'Only excel files are allowed!';
        return cb(new Error(req.fileValidationError), false);
    }
    cb(null, true);
};

exports.FilesFilter = FilesFilter;
exports.excelFilter = excelFilter;